const round = (value, decimals = 4) => {
  const factor = 10 ** decimals;
  return Math.round((Number(value) + Number.EPSILON) * factor) / factor;
};

const toNonNegativeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : 0;
};

const normalizeName = (value = '') => String(value)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const isYieldTrackingProduct = (product) => {
  if (!product || String(product.type || '').toLowerCase() !== 'insumo') return false;
  if (String(product.unit || '').toLowerCase() !== 'g') return false;
  if (typeof product?.yieldConfig?.enabled === 'boolean') return product.yieldConfig.enabled;
  return normalizeName(product.name).includes('mezcla');
};

export const calculateYieldEntry = ({ purchasedQuantity, usableQuantity, totalCost }) => {
  const purchased = toNonNegativeNumber(purchasedQuantity);
  const usable = toNonNegativeNumber(usableQuantity);
  const cost = toNonNegativeNumber(totalCost);
  const waste = Math.max(purchased - usable, 0);

  return {
    purchasedQuantity: round(purchased),
    usableQuantity: round(usable),
    wasteQuantity: round(waste),
    yieldPercent: purchased > 0 ? round((usable / purchased) * 100, 2) : 0,
    wastePercent: purchased > 0 ? round((waste / purchased) * 100, 2) : 0,
    purchaseUnitCost: purchased > 0 ? round(cost / purchased) : 0,
    effectiveUnitCost: usable > 0 ? round(cost / usable) : 0,
    totalCost: round(cost, 2),
  };
};

export const validateYieldEntry = ({ purchasedQuantity, usableQuantity }) => {
  const purchased = toNonNegativeNumber(purchasedQuantity);
  const usable = toNonNegativeNumber(usableQuantity);
  if (!(purchased > 0)) return 'La cantidad comprada/procesada debe ser mayor que cero.';
  if (!(usable > 0)) return 'La cantidad aprovechable debe ser mayor que cero.';
  if (usable > purchased) return 'La cantidad aprovechable no puede superar la cantidad comprada/procesada.';
  return '';
};

